import { AppRoutes } from '@/shared/constants/app-routes.constant';
import { USER_DOMAIN } from '@/shared/constants/user-domain.constant';

import { MultiRoutes } from '../types/navigation-item.interface';

const YACHTING_ROUTES: MultiRoutes = {
	multiView: AppRoutes.MultiYachtView,
	singleView: AppRoutes.YachtView,
	management: AppRoutes.YachtsFleet,
	editManagement: AppRoutes.EditYacht,
};

export const DOMAIN_ROUTES: Record<USER_DOMAIN, MultiRoutes> = {
	[USER_DOMAIN.YACHTING]: YACHTING_ROUTES,
	[USER_DOMAIN.INDUSTRIAL]: {
		multiView: AppRoutes.MultiPlantView,
		singleView: AppRoutes.PlantView,
		management: AppRoutes.PlantsManagement,
		editManagement: AppRoutes.EditPlant,
	},
	// TODO: Add Residential routes when Residential routing is enabled.
	[USER_DOMAIN.RESIDENTIAL]: YACHTING_ROUTES,
};
